<template>
<svg viewBox="0 0 130 130" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-psm-wjj`]" width="1em" height="1em" v-bind="$attrs"><defs><linearGradient x1="59.971%" y1="14.487%" x2="29.513%" y2="82.292%" id="svg_dd20082b4c__a"><stop stop-color="#1BA8AF" stop-opacity=".59" offset="0%"/><stop stop-color="#FFF" stop-opacity=".394" offset="100%"/></linearGradient></defs><g fill="none" fill-rule="evenodd"><path d="M126,31.9998242 L126,116 L14,116 L14,18 L50.3997488,18 L57.3996847,24.9999121 L126,24.9999121 L126,31.9998242 Z M24,105 L116,105 L116,37 L24,37 L24,105 Z M77,95 L105,95 L105,84 L77,84 L77,95 Z" :fill="useCurrentColor ? 'currentColor' : 'url(#svg_dd20082b4c__a)'"/><path d="M121,31.9998242 L121,116 L9,116 L9,18 L45.3997488,18 L52.3996847,24.9999121 L121,24.9999121 L121,31.9998242 Z M19,105 L111,105 L111,37 L19,37 L19,105 Z M72,95 L100,95 L100,84 L72,84 L72,95 Z" :fill="useCurrentColor ? 'currentColor' : '#1BA8AF'"/></g></svg>
</template>
<script>

export default {
  name: 'IconPsmWjj',
  props: {
    prefix: {
        type: String,
        default: 'psm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
